module.exports = __webpack_public_path__ + "img/00038.d4e3d67e.webp";